import script from "./PrimeContractFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimeContractFilters.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__